import * as React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { ThemeContext } from "@emotion/core";
import PropTypes from "prop-types";
import { styleConstants } from "nectar-ui";
import Flex from "../../Flex";
import { NectarTheme } from "../../../../typings/theme";

interface SpinnerLoadingProps {
  color?: typeof styleConstants.colors[keyof typeof styleConstants.colors];
  size?: number;
  containerStyle?: object;
  css?: React.CSSProperties;
}

const { PRIMARY } = styleConstants.colors;

const SpinnerLoading = ({ css, color = PRIMARY, size = 16, containerStyle = {} }: SpinnerLoadingProps) => {
  // @ts-ignore
  const theme = React.useContext<NectarTheme["theme"]>(ThemeContext);

  const useColor = color ? theme.colors[color as keyof typeof theme.colors] : theme.colors.primary500;

  return (
    <Flex
      justify="center"
      data-testid="spinner-loading"
      align="center"
      style={containerStyle}
    >
      {/* @ts-ignore */}
      <ClipLoader size={size} sizeUnit="px" color={useColor} cssOverride={css} />
    </Flex>
  );
};

export default SpinnerLoading;
